<template>
  <div class="rm-root">
    <!-- CARREGANDO -->
    <div class="rm-center" v-if="carregamento == 'CARREGANDO'">
      <v-progress-circular indeterminate size="48" width="4" color="#2f7d74"></v-progress-circular>
      <p class="rm-loading-text">Carregando questionário...</p>
    </div>

    <!-- ERRO -->
    <div class="rm-center" v-if="carregamento == 'ERRO'">
      <div class="rm-error-badge"><v-icon size="46" color="#c62828">mdi-alert-circle-outline</v-icon></div>
      <h3 class="rm-error">{{ mensagemErro }}</h3>
    </div>

    <!-- CARREGADO -->
    <div v-if="carregamento == 'CARREGADO'" class="rm-shell">
      <!-- HERO: dados da empresa + progresso (durante as perguntas) -->
      <header class="rm-hero-bar" v-if="stepper >= 2 && stepper <= perguntas.length + 1">
        <div class="rm-hero-brand">
          <span class="rm-hero-logo" v-if="empresa.logoUrl">
            <img :src="empresa.logoUrl" alt="">
          </span>
        </div>
        <div class="rm-hero-progress">
          <div class="rm-track">
            <div class="rm-track-fill" :style="{ width: (((stepper - 1) / perguntas.length) * 100) + '%' }"></div>
          </div>
          <span class="rm-hero-count">Pergunta {{ stepper - 1 }} de {{ perguntas.length }}</span>
        </div>
      </header>

      <v-stepper v-model="stepper" class="rm-stepper" flat>
        <v-stepper-header v-show="false">
          <v-stepper-step :complete="stepper > 1" step="1" class="stepperHeader">Início</v-stepper-step>
          <div v-for="(item, index) in perguntas" :key="item.id">
            <v-stepper-step :complete="stepper > (index + 2)" :step="index + 2" class="stepperHeader">{{ item.titulo.substring(0,10) }}</v-stepper-step>
          </div>
          <v-stepper-step :step="quantidadeHeader" class="stepperHeader">Final</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <!-- INTRO -->
          <v-stepper-content step="1" class="rm-content">
            <div class="rm-stage rm-intro" v-if="empresa.bannerInicial">
              <img :src="empresa.bannerInicial" class="rm-banner" @click="stepper++">
            </div>
            <div class="rm-stage rm-intro" v-else>
              <img v-if="empresa.avatarUrl" :src="empresa.avatarUrl" class="rm-avatar" alt="">
              <h1 class="rm-hero">Queremos a sua opinião</h1>
              <p class="rm-hero-sub">Leva só um minutinho — e a sua resposta faz toda a diferença.</p>
              <button class="rm-cta" v-if="questionario.ativo" @click="stepper++">
                Começar <v-icon right dark>mdi-arrow-right</v-icon>
              </button>
              <p class="rm-lgpd" v-if="questionario.exibeTermoLgpd">
                Ao continuar, você concorda com nossas
                <a target="_blank" :href="configuracoes.urlPoliticaPrivacidade" @click.stop>políticas de privacidade e tratamento de dados</a>.
              </p>
            </div>
          </v-stepper-content>

          <!-- PERGUNTAS -->
          <div v-for="(item, index) in perguntas" :key="item.id">
            <v-stepper-content :step="index + 2" class="rm-content">
              <div class="rm-stage">
                <h2 class="rm-q-title">{{ item.titulo }}</h2>

                <!-- NPS -->
                <div v-if="item.tipo == 'NPS'" class="rm-faces">
                  <button
                    v-for="number in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                    :key="number"
                    class="rm-face"
                    @click="salvaResposta(number, '', '', '', 'SIM', undefined, undefined, undefined, item.id, (index + 2))"
                  >
                    <img :src="require(`../../assets/artboard${number}.png`)" alt="">
                  </button>
                </div>

                <!-- MÚLTIPLA ESCOLHA -->
                <div v-if="item.tipo == 'MÚLTIPLA ESCOLHA'" class="rm-multi">
                  <button class="rm-multi-card" @click="salvaResposta(0, '', '', 'RUIM', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                    <img :src="require('../../assets/buttonruim.png')" alt="">
                  </button>
                  <button class="rm-multi-card" @click="salvaResposta(0, '', '', 'BOM', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                    <img :src="require('../../assets/buttonbom.png')" alt="">
                  </button>
                  <button class="rm-multi-card" @click="salvaResposta(0, '', '', 'OTIMO', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                    <img :src="require('../../assets/buttonotimo.png')" alt="">
                  </button>
                  <button class="rm-multi-card" @click="salvaResposta(0, '', '', 'EXCELENTE', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                    <img :src="require('../../assets/buttonexcelente.png')" alt="">
                  </button>
                </div>

                <!-- FEEDBACK -->
                <div v-if="item.tipo == 'FEEDBACK'" class="rm-field">
                  <textarea class="rm-textarea" rows="4" placeholder="Escreva aqui..." v-model="textoFeedback"></textarea>
                  <button class="rm-cta" @click="salvaResposta(0, textoFeedback, '', '', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                    Enviar <v-icon right dark>mdi-send</v-icon>
                  </button>
                </div>

                <!-- TELEFONE -->
                <div v-if="item.tipo == 'TELEFONE'" class="rm-field">
                  <input
                    class="rm-input"
                    type="tel"
                    maxlength="15"
                    placeholder="(00) 00000-0000"
                    :value="textoTelefone"
                    @input="textoTelefone = formataTelefone($event.target.value)"
                  >
                  <button class="rm-cta" @click="salvaResposta(0, '', textoTelefone, '', 'NAO', undefined, undefined, undefined, item.id, (index + 2))">
                    Enviar <v-icon right dark>mdi-send</v-icon>
                  </button>
                </div>

                <!-- ESCALA -->
                <div v-if="item.tipo == 'ESCALA'" class="rm-scale-wrap">
                  <div class="rm-scale">
                    <button
                      v-for="number in retornaEscala(item.escalaValor)"
                      :key="number"
                      class="rm-scale-btn"
                      @click="salvaResposta(0, '', '', '', 'NAO', undefined, undefined, number, item.id, (index + 2))"
                    >{{ number }}</button>
                  </div>
                  <div class="rm-scale-legend"><span>1 · Negativo</span><span>Positivo · {{ item.escalaValor }}</span></div>
                </div>

                <!-- DICOTÔMICA -->
                <div v-if="item.tipo == 'DICOTÔMICA'" class="rm-yesno">
                  <button class="rm-yn rm-yes" @click="salvaResposta(0, '', '', '', 'NAO', 'SIM', undefined, undefined, item.id, (index + 2))">
                    <v-icon>mdi-thumb-up</v-icon><span>Sim</span>
                  </button>
                  <button class="rm-yn rm-no" @click="salvaResposta(0, '', '', '', 'NAO', 'NÃO', undefined, undefined, item.id, (index + 2))">
                    <v-icon>mdi-thumb-down</v-icon><span>Não</span>
                  </button>
                </div>

                <!-- ESCOLHA ÚNICA -->
                <div v-if="item.tipo == 'ESCOLHA ÚNICA'" class="rm-choices">
                  <button
                    v-for="opcao in item.escolhas"
                    :key="opcao"
                    class="rm-choice"
                    @click="salvaResposta(0, '', '', '', 'NAO', undefined, opcao, undefined, item.id, (index + 2))"
                  >
                    <span class="rm-choice-dot"></span>{{ opcao }}
                  </button>
                </div>

                <!-- ESCOLHA ÚNICA COM FOTO -->
                <div v-if="item.tipo == 'ESCOLHA ÚNICA COM FOTO'" class="rm-photo">
                  <div class="rm-photo-grid">
                    <div
                      v-for="opcao in item.escolhas"
                      :key="opcao.nome"
                      class="rm-photo-card"
                      :class="{ 'rm-photo-selected': opcao.selecionado }"
                      @click="selecionaOpcao(opcao.nome, item.id)"
                    >
                      <img :src="opcao.foto" alt="">
                      <span class="rm-photo-name">{{ opcao.nome }}</span>
                      <span class="rm-photo-check"><v-icon small dark>mdi-check</v-icon></span>
                    </div>
                  </div>
                  <button
                    class="rm-cta rm-photo-confirm"
                    v-if="opcaoSelecionada"
                    @click="salvaResposta(0, '', '', '', 'NAO', undefined, opcaoSelecionada, undefined, item.id, (index + 2))"
                  >Confirmar <v-icon right dark>mdi-check</v-icon></button>
                </div>
              </div>
            </v-stepper-content>
          </div>

          <!-- FINAL -->
          <v-stepper-content :step="quantidadeHeader" class="rm-content">
            <div class="rm-stage rm-final">
              <template v-if="perguntaInformativo.length == 0">
                <div class="rm-final-check"><v-icon size="54" color="#6fd6cd">mdi-check</v-icon></div>
                <h1 class="rm-hero">Obrigado pela sua resposta!</h1>
                <p class="rm-hero-sub">Sua opinião nos ajuda a melhorar cada vez mais.</p>
              </template>
              <template v-else>
                <div class="rm-final-check"><v-icon size="54" color="#6fd6cd">mdi-information-outline</v-icon></div>
                <h1 class="rm-hero rm-hero-info">{{ perguntaInformativo[0].textoInformativo }}</h1>
              </template>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <!-- Rodapé -->
    <div class="rm-footer" v-if="carregamento == 'CARREGADO'">
      <img src="../../assets/logoAvalizeHorizontalBranca.png" class="rm-footer-brand" alt="Avalize">
      <img v-if="configuracoes.urlLogoEmpresa" :src="configuracoes.urlLogoEmpresa" class="rm-footer-logo" alt="">
    </div>

    <loading :active.sync="isLoading" :can-cancel="true" color="#2f7d74" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  /* import vueCard from 'vue-card-express'; */
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl, /* modelBoleto */ } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    components: { Snackbar, Loading },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        isLoading: false,
        fullPage: true,
        carregamento: '',
        textoFeedback: '',
        textoTelefone: '',
        opcaoSelecionada: '',
        codPesquisa: '',
        questionario: [],
        perguntas: [],
        empresa: [],
        stepper: 1,
        quantidadeHeader: 0,
        mensagemErro: '',
        perguntaInformativo: [],
        configuracoes: {},
        dictionary: {
          custom: {
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
            },
            cpftitular: {
              required: () => 'Informe o número do cartão de crédito',
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
            dateOfBirth: {
                required: () => 'Informe a Data de Nascimento' ,
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
          }
        }
      }
    },

    created: async function () {
      await this.configuracoesGerais()
    },

    mounted: function () {
      this.geraIdentificador()
      this.pegaParametrosUrl()
      setTimeout(() => {
        let number = document.getElementsByClassName('stepperHeader')
        this.quantidadeHeader = number.length
      }, 1000);
    },

    watch: {
      stepper() {
        if (this.stepper == this.quantidadeHeader) {
          setTimeout(() => {
            this.stepper = 1
            this.geraCodPesquisa()
          }, 5000);
        }
      },
    },

    methods: {
      async configuracoesGerais() {
        await axios.get(baseApiUrl + 'Configuracoes/info')
        .then(response => {
          if (response.data) {
            this.configuracoes = response.data
          }
        })
      },

      async pegaParametrosUrl() {
        this.carregamento = 'CARREGANDO'
        this.isLoading = true
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          var paramArray = {};                        // Criar objeto que vai conter os parametros
          for (var i = 0; i < params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');         // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];          // Adicionar ao objeto criado antes
          }
          if (paramArray['mac']) {
            this.pegaInformacoesPainel(paramArray['mac'].replaceAll('%3A', ':'))
          }
        }
        this.isLoading = false
      },

      async pegaInformacoesPainel(macAddress) {
        await axios.post(baseApiUrl + 'Dispositivos/getQuestionario', { "mac": macAddress })
        .then(response => {
          if (response.data) {
            this.geraCodPesquisa()
            this.questionario = response.data.questionario
            this.empresa = response.data.empresa
            this.perguntaInformativo = response.data.perguntas.filter(pergunta => pergunta.tipo === 'INFORMATIVO')
            if (this.perguntaInformativo.length >= 1) {
              this.perguntas = response.data.perguntas.filter(pergunta => pergunta.id !== this.perguntaInformativo[0].id)
            } else {
              this.perguntas = response.data.perguntas
            }
            this.carregamento = 'CARREGADO'
          }
        })
        .catch(error => {
          this.carregamento = 'ERRO'

          if (error.response.data.error.message.includes('não cadastrado')) {
            this.mensagemErro = 'MAC ' + macAddress + ' não cadastrado.'
          } else {
            this.mensagemErro = error.response.data.error.message
          }
        })
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },

      async salvaResposta(nota, feedback, telefone, classificacao, nps, dicotomica, escolhaUnica, escala, perguntaId, passo) {
        let dados = {
          "canal": "TABLET",
          "nota": nota,
          "classificacao": classificacao,
          "feedback": feedback,
          "telefone": telefone,
          "padraoNPS": nps,
          "perguntaId": perguntaId,
          "questionarioId": this.questionario.id,
          "codPesquisa": this.codPesquisa,
          "dicotomica": dicotomica,
          "escolhaUnica": escolhaUnica,
          "escala": escala,
          "identificador": this.identificador,
        }

        await axios.post(baseApiUrl + 'Respostas/salvar', dados)
        .then(response => {
          if (response.data) {
            this.stepper = passo + 1
            this.textoFeedback = ''
            this.textoTelefone = ''
          }
        })
      },

      async geraCodPesquisa() {
        await axios.get(baseApiUrl + 'Respostas/geraCodPesquisa')
        .then(response => {
          if (response.data) {
            this.codPesquisa = response.data.codPesquisa
          }
        })
      },

      retornaEscala(escalaValor) {
        let listaEscala = []

        for (let i = 0; i < escalaValor + 1; i++) {
          if (i > 0) {
            listaEscala.push(i)
          }
        }

        return listaEscala
      },

      formataTelefone(valor) {
        const d = (valor || '').replace(/\D/g, '').slice(0, 11)
        if (d.length === 0) return ''
        if (d.length < 3) return `(${d}`
        if (d.length < 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`
        // Até 10 dígitos: fixo (99) 9999-9999 | 11 dígitos: celular (99) 99999-9999
        if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`
        return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`
      },

      selecionaOpcao(opcao, perguntaId) {
        for (let i = 0; i < this.perguntas.length; i++) {
          if (this.perguntas[i].id == perguntaId) {
            for (let j = 0; j < this.perguntas[i].escolhas.length; j++) {
              if (this.perguntas[i].escolhas[j].nome == opcao) {
                this.perguntas[i].escolhas[j].selecionado = !this.perguntas[i].escolhas[j].selecionado

                if (this.perguntas[i].escolhas[j].selecionado) {
                  this.opcaoSelecionada = this.perguntas[i].escolhas[j].nome
                } else {
                  this.opcaoSelecionada = ''
                }
              } else {
                this.perguntas[i].escolhas[j].selecionado = false
              }
            }
          }
        }
      },

      async geraIdentificador() {
        if (localStorage.getItem('identificador')) {
          this.identificador = localStorage.getItem('identificador')
        } else {
          this.identificador = new Date().getTime().toString()
          localStorage.setItem('identificador', this.identificador)
        }
      },

    }
  }
</script>

<style scoped>
  /* ===== Experiência imersiva ===== */
  .rm-root {
    position: relative;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    background:
      radial-gradient(1100px 560px at 50% -8%, rgba(59, 168, 162, 0.20), transparent 60%),
      radial-gradient(820px 520px at 108% 112%, rgba(47, 125, 116, 0.18), transparent 55%),
      linear-gradient(160deg, #2b3a37 0%, #1b2422 100%);
    font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  .rm-shell { position: relative; z-index: 1; flex: 1 1 auto; }

  /* Stepper transparente */
  .rm-stepper {
    background: transparent !important;
    box-shadow: none !important;
  }
  .rm-stepper ::v-deep .v-stepper__content,
  .rm-content {
    padding: 0 !important;
  }
  .rm-stepper ::v-deep .v-stepper__wrapper {
    overflow: visible;
  }

  /* Palco central de cada passo */
  .rm-stage {
    max-width: 820px;
    margin: 0 auto;
    min-height: calc(100vh - 210px);
    padding: 28px 24px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    animation: rmIn .5s cubic-bezier(.2, .7, .3, 1) both;
  }
  @keyframes rmIn {
    from { opacity: 0; transform: translateY(22px); }
    to { opacity: 1; transform: none; }
  }

  /* Hero compacto com dados da empresa */
  .rm-hero-bar {
    position: relative; z-index: 1;
    width: 100%; max-width: 820px; margin: 0 auto;
    padding: 22px 24px 4px;
    display: flex; flex-direction: column; gap: 14px;
    animation: rmIn .4s ease both;
  }
  .rm-hero-brand { display: flex; align-items: center; justify-content: center; }
  .rm-hero-logo {
    flex: none;
    display: flex; align-items: center; justify-content: center;
  }
  .rm-hero-logo img { max-width: 200px; max-height: 64px; object-fit: contain; }
  .rm-hero-progress { display: flex; align-items: center; gap: 14px; }
  .rm-hero-progress .rm-track { flex: 1 1 auto; }
  .rm-hero-count {
    font-size: 12px; font-weight: 700; letter-spacing: .6px;
    text-transform: uppercase; color: #6fd6cd; white-space: nowrap;
  }

  .rm-track {
    height: 8px; border-radius: 999px;
    background: rgba(255, 255, 255, .14); overflow: hidden;
  }
  .rm-track-fill {
    height: 100%; border-radius: 999px;
    background: linear-gradient(90deg, #2f7d74, #3ba8a2);
    transition: width .45s cubic-bezier(.3, .8, .3, 1);
  }
  .rm-q-title {
    font-size: clamp(24px, 4vw, 40px);
    font-weight: 800; line-height: 1.18; color: #ffffff;
    margin: 0 0 40px; max-width: 760px;
  }

  /* Hero (intro / final) */
  .rm-hero {
    font-size: clamp(30px, 6vw, 54px);
    font-weight: 800; color: #ffffff; line-height: 1.08; margin: 0 0 14px;
  }
  .rm-hero-info { font-size: clamp(22px, 4vw, 34px); }
  .rm-hero-sub { font-size: clamp(15px, 2vw, 19px); color: rgba(255, 255, 255, .72); margin: 0 0 34px; max-width: 540px; }
  .rm-avatar {
    max-width: min(340px, 82%);
    max-height: 200px;
    width: auto; height: auto;
    object-fit: contain;
    margin-bottom: 28px;
  }
  .rm-banner { max-width: 100%; border-radius: 26px; cursor: pointer; box-shadow: 0 24px 60px rgba(0, 0, 0, .18); }
  .rm-lgpd { margin-top: 26px; font-size: 12.5px; color: rgba(255, 255, 255, .6); max-width: 460px; }
  .rm-lgpd a { color: #6fd6cd; text-decoration: underline; }

  /* Botão principal (pílula com gradiente) */
  .rm-cta {
    display: inline-flex; align-items: center; gap: 6px;
    border: none; cursor: pointer;
    padding: 16px 42px;
    font-size: 17px; font-weight: 700; letter-spacing: .3px;
    color: #fff;
    background: linear-gradient(135deg, #2f7d74, #3ba8a2);
    border-radius: 999px;
    transition: transform .16s ease, filter .16s ease;
  }
  .rm-cta:hover { transform: translateY(-2px); filter: brightness(1.04); }
  .rm-cta:active { transform: translateY(0); }

  /* NPS — carinhas em cartões */
  .rm-faces { display: flex; flex-wrap: wrap; gap: 12px; justify-content: center; max-width: 780px; }
  .rm-face {
    border: none; cursor: pointer; background: #fff;
    padding: 12px; border-radius: 18px;
    display: flex; align-items: center; justify-content: center;
    box-shadow: 0 8px 22px rgba(20, 40, 38, .10);
    transition: transform .15s ease, box-shadow .15s ease;
  }
  .rm-face img { width: 46px; height: auto; display: block; }
  .rm-face:hover { transform: translateY(-5px); box-shadow: 0 18px 34px rgba(20, 40, 38, .18); }

  /* Telas largas: as 11 carinhas do NPS em uma única linha */
  @media (min-width: 860px) {
    .rm-faces { flex-wrap: nowrap; gap: 8px; max-width: 100%; }
    .rm-faces .rm-face { padding: 10px; }
    .rm-faces .rm-face img { width: 40px; }
  }

  /* Múltipla escolha */
  .rm-multi { display: flex; flex-wrap: wrap; gap: 16px; justify-content: center; }
  .rm-multi-card {
    border: none; cursor: pointer; background: #fff;
    width: 132px; padding: 24px; border-radius: 22px;
    display: flex; align-items: center; justify-content: center;
    box-shadow: 0 10px 26px rgba(20, 40, 38, .10);
    transition: transform .15s ease, box-shadow .15s ease;
  }
  .rm-multi-card img { width: 64px; height: auto; display: block; }
  .rm-multi-card:hover { transform: translateY(-5px); box-shadow: 0 20px 38px rgba(20, 40, 38, .18); }

  /* Campos (feedback / telefone) */
  .rm-field { width: 100%; max-width: 560px; display: flex; flex-direction: column; align-items: center; gap: 24px; }
  .rm-textarea, .rm-input {
    width: 100%; border: 2px solid #d9e3e1; border-radius: 18px;
    padding: 18px 20px; font-size: 17px; color: #13201e; background: #fff;
    outline: none; font-family: inherit;
    transition: border-color .15s ease, box-shadow .15s ease;
  }
  .rm-textarea { resize: vertical; min-height: 120px; }
  .rm-input { text-align: center; font-size: 24px; letter-spacing: 1px; font-weight: 600; }
  .rm-textarea:focus, .rm-input:focus { border-color: #3ba8a2; box-shadow: 0 0 0 4px rgba(59, 168, 162, .16); }

  /* Escala — botões circulares */
  .rm-scale-wrap { width: 100%; max-width: 700px; }
  .rm-scale { display: flex; flex-wrap: wrap; gap: 12px; justify-content: center; }
  .rm-scale-btn {
    border: none; cursor: pointer; width: 62px; height: 62px; border-radius: 50%;
    font-size: 21px; font-weight: 800; color: #2f7d74; background: #fff;
    box-shadow: 0 8px 20px rgba(20, 40, 38, .10);
    transition: transform .15s ease, box-shadow .15s ease, background .15s ease, color .15s ease;
  }
  .rm-scale-btn:hover {
    transform: translateY(-4px); color: #fff;
    background: linear-gradient(135deg, #2f7d74, #3ba8a2);
  }
  .rm-scale-legend { display: flex; justify-content: space-between; margin-top: 18px; font-size: 13px; color: rgba(255, 255, 255, .6); font-style: italic; }

  /* Telas largas: a escala em uma única linha */
  @media (min-width: 860px) {
    .rm-scale { flex-wrap: nowrap; gap: 10px; max-width: 100%; }
  }

  /* Dicotômica — dois grandes cartões */
  .rm-yesno { display: flex; gap: 20px; flex-wrap: wrap; justify-content: center; width: 100%; max-width: 560px; }
  .rm-yn {
    border: none; cursor: pointer; flex: 1; min-width: 200px;
    padding: 32px 20px; border-radius: 26px; background: #fff;
    display: flex; flex-direction: column; align-items: center; gap: 12px;
    font-size: 22px; font-weight: 800;
    box-shadow: 0 14px 32px rgba(20, 40, 38, .10);
    transition: transform .15s ease, box-shadow .15s ease;
  }
  .rm-yn ::v-deep .v-icon { font-size: 46px !important; }
  .rm-yes { color: #2e7d32; } .rm-yes ::v-deep .v-icon { color: #2e7d32 !important; }
  .rm-no { color: #c62828; } .rm-no ::v-deep .v-icon { color: #c62828 !important; }
  .rm-yn:hover { transform: translateY(-5px); box-shadow: 0 22px 44px rgba(20, 40, 38, .18); }

  /* Escolha única — linhas grandes */
  .rm-choices { width: 100%; max-width: 580px; display: flex; flex-direction: column; gap: 14px; }
  .rm-choice {
    display: flex; align-items: center; gap: 14px;
    border: 2px solid #e2e9e8; cursor: pointer; background: #fff;
    padding: 20px 24px; border-radius: 16px;
    font-size: 18px; font-weight: 600; color: #1f2a2a; text-align: left;
    box-shadow: 0 6px 16px rgba(20, 40, 38, .06);
    transition: transform .14s ease, border-color .15s ease, box-shadow .15s ease;
  }
  .rm-choice-dot { width: 14px; height: 14px; border-radius: 50%; border: 2px solid #c2d3d0; flex: none; transition: all .15s ease; }
  .rm-choice:hover { border-color: #3ba8a2; transform: translateX(4px); box-shadow: 0 12px 26px rgba(47, 125, 116, .15); }
  .rm-choice:hover .rm-choice-dot { border-color: #2f7d74; background: #2f7d74; }

  /* Escolha única com foto */
  .rm-photo { width: 100%; max-width: 800px; }
  .rm-photo-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 16px; }
  .rm-photo-card {
    position: relative; cursor: pointer; background: #fff;
    border-radius: 18px; overflow: hidden; border: 3px solid transparent;
    box-shadow: 0 10px 26px rgba(20, 40, 38, .10);
    transition: transform .15s ease, border-color .15s ease, box-shadow .15s ease;
  }
  .rm-photo-card img { width: 100%; height: 150px; object-fit: cover; display: block; }
  .rm-photo-name { display: block; padding: 12px; font-weight: 700; color: #1f2a2a; }
  .rm-photo-check {
    position: absolute; top: 10px; right: 10px;
    width: 30px; height: 30px; border-radius: 50%;
    background: #2f7d74; display: flex; align-items: center; justify-content: center;
    opacity: 0; transform: scale(.6); transition: all .15s ease;
  }
  .rm-photo-card:hover { transform: translateY(-4px); box-shadow: 0 18px 36px rgba(20, 40, 38, .16); }
  .rm-photo-selected { border-color: #2f7d74; box-shadow: 0 18px 38px rgba(47, 125, 116, .26); }
  .rm-photo-selected .rm-photo-check { opacity: 1; transform: scale(1); }
  .rm-photo-confirm { margin-top: 30px; }

  /* Final */
  .rm-final-check {
    width: 100px; height: 100px; border-radius: 50%;
    background: rgba(111, 214, 205, .14);
    display: flex; align-items: center; justify-content: center; margin-bottom: 26px;
  }

  /* Rodapé */
  .rm-footer {
    position: relative; z-index: 1;
    display: flex; align-items: center; justify-content: center; gap: 22px;
    padding: 12px 16px 24px;
  }
  .rm-footer-brand { height: 26px; width: auto; opacity: .8; }
  .rm-footer-logo { width: 122px; height: auto; opacity: .65; }

  /* Carregando / erro */
  .rm-center {
    position: relative; z-index: 1;
    min-height: 100vh; display: flex; flex-direction: column;
    align-items: center; justify-content: center; gap: 18px;
  }
  .rm-loading-text { color: rgba(255, 255, 255, .75); font-size: 16px; }
  .rm-error-badge {
    width: 92px; height: 92px; border-radius: 50%;
    background: rgba(198, 40, 40, .1);
    display: flex; align-items: center; justify-content: center;
  }
  .rm-error { color: #ffffff; font-weight: 600; max-width: 520px; text-align: center; padding: 0 20px; }
</style>
